import React, { useState } from 'react';
import CommissionRules from './CommissionRules';
import CommissionCalculator from './CommissionCalculator';
import CommissionHistory from './CommissionHistory';
// Comentando temporariamente para evitar os erros
// import CommissionDashboard from './CommissionDashboard';
// import PerformanceAnalysis from './PerformanceAnalysis';

const CommissionManager = ({ salonId, professionals, services = [] }) => {
  // Alterado para 'calculator' como tab inicial
  const [activeTab, setActiveTab] = useState('calculator');
  
  return (
    <div className="bg-white shadow rounded-lg overflow-hidden">
      {/* Tabs de navegação */}
      <div className="bg-white border-b border-gray-200">
        <nav className="flex -mb-px overflow-x-auto">
          {/* Comentado temporariamente
          <button
            onClick={() => setActiveTab('dashboard')}
            className={`whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm ${
              activeTab === 'dashboard'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Dashboard
          </button>
          */}
          <button
            onClick={() => setActiveTab('calculator')}
            className={`whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm ${
              activeTab === 'calculator'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Comissões Pendentes
          </button>
          <button
            onClick={() => setActiveTab('history')}
            className={`whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm ${
              activeTab === 'history'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Histórico de Pagamentos
          </button>
          {/* Comentado temporariamente
          <button
            onClick={() => setActiveTab('performance')}
            className={`whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm ${
              activeTab === 'performance'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Análise de Desempenho
          </button>
          */}
          <button
            onClick={() => setActiveTab('rules')}
            className={`whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm ${
              activeTab === 'rules'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            Regras de Comissão
          </button>
        </nav>
      </div>
      
      {/* Conteúdo da tab ativa */}
      <div className="mt-2">
        {/* Comentado temporariamente
        {activeTab === 'dashboard' && (
          <CommissionDashboard 
            salonId={salonId} 
            professionals={professionals}
            setActiveTab={setActiveTab}
          />
        )}
        */}
        
        {activeTab === 'rules' && (
          <CommissionRules 
            salonId={salonId} 
            professionals={professionals} 
            services={services} 
          />
        )}
        
        {activeTab === 'calculator' && (
          <CommissionCalculator 
            salonId={salonId} 
            professionals={professionals} 
          />
        )}
        
        {activeTab === 'history' && (
          <CommissionHistory 
            salonId={salonId} 
            professionals={professionals} 
          />
        )}
        
        {/* Comentado temporariamente
        {activeTab === 'performance' && (
          <PerformanceAnalysis
            salonId={salonId}
            professionals={professionals}
          />
        )}
        */}
      </div>
    </div>
  );
};

export default CommissionManager; 